/**
 * Single resolution path for patient-switch Yes/No: same strings for click and voice
 * (widget sends this text to the hosted command API).
 */
export function patientSwitchConfirmationSubmittedText(choice: 'yes' | 'no', localeIsFrench: boolean): string {
  if (choice === 'yes') return localeIsFrench ? 'oui continuer' : 'yes proceed'
  return localeIsFrench ? 'non annuler' : 'no cancel'
}

export function resolvePatientSwitchConfirmation(
  choice: 'yes' | 'no',
  localeIsFrench: boolean,
): { apiCommandText: string } {
  return { apiCommandText: patientSwitchConfirmationSubmittedText(choice, localeIsFrench) }
}
